import React from 'react';

/**
 * LogoMark — Versão vetorial da logo Coutin Studio.
 * Replica visualmente a marca (COUTIN branco + traço diagonal azul no O + STUDIO).
 * Substituir por PNG/SVG oficial quando disponível — trocar o retorno pela <img />.
 *
 * Props:
 *  - className: extra classes
 *  - dark: se true, texto escuro (para fundos claros)
 *  - showTagline: se true, mostra "STUDIO" abaixo
 */
const LogoMark = ({ className = '', dark = false, showTagline = true, accent = '#2540A3' }) => {
  const textColor = dark ? '#0B0B0F' : '#F5F5F5';
  const accentColor = accent;

  return (
    <div
      className={`inline-flex flex-col items-center leading-none ${className}`}
      data-testid="logo-coutin-studio"
      aria-label="Coutin Studio"
    >
      {/* COUTIN wordmark with diagonal slash */}
      <div className="relative">
        <span
          className="font-display font-black tracking-tight select-none"
          style={{
            color: textColor,
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 900,
            fontSize: '1em',
            letterSpacing: '-0.02em',
          }}
        >
          C<span style={{ position: 'relative' }}>
            O
            {/* Diagonal blue slash through the O */}
            <svg
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              style={{
                position: 'absolute',
                top: '15%',
                left: '10%',
                width: '80%',
                height: '70%',
                pointerEvents: 'none',
              }}
            >
              <path
                d="M 5 75 Q 50 55 95 25"
                stroke={accentColor}
                strokeWidth="18"
                strokeLinecap="round"
                fill="none"
              />
            </svg>
          </span>UTIN
        </span>
      </div>

      {/* STUDIO */}
      {showTagline && (
        <span
          className="select-none mt-1"
          style={{
            color: textColor,
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 400,
            fontSize: '0.24em',
            letterSpacing: '0.55em',
            paddingLeft: '0.55em', /* balance letter-spacing */
            opacity: 0.95,
          }}
        >
          STUDIO
        </span>
      )}
    </div>
  );
};

export default LogoMark;
